const OPENID_PROVIDERS = {
  OPENID:     'OpenIDConnectAuth',
  GIGYA:      'GigyaOpenIDConnectAuth',
  KEYCLOAK:   'KeycloakAuth',
  SALESFORCE: 'SalesforceAuth',
  SHOPIFY:    'ShopifyAuth',
  CUSTOM:     'Custom',
};

const OPENID_PROVIDERS_LIST = [
  { name: 'OpenID', id: OPENID_PROVIDERS.OPENID },
  { name: 'Gigya', id: OPENID_PROVIDERS.GIGYA },
  { name: 'Keycloak', id: OPENID_PROVIDERS.KEYCLOAK },
  { name: 'Salesforce', id: OPENID_PROVIDERS.SALESFORCE },
  { name: 'Shopify', id: OPENID_PROVIDERS.SHOPIFY },
  { name: 'Custom', id: OPENID_PROVIDERS.CUSTOM },
];

export default { OPENID_PROVIDERS_LIST };
